import { render, staticRenderFns } from "./language-login.vue?vue&type=template&id=80228bfa&scoped=true&"
import script from "./language-login.vue?vue&type=script&lang=js&"
export * from "./language-login.vue?vue&type=script&lang=js&"
import style0 from "./language-login.vue?vue&type=style&index=0&id=80228bfa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80228bfa",
  null
  
)

export default component.exports